export default __webpack_public_path__ + "static/media/default.a03cd9f1.png";